module.exports = __webpack_public_path__ + "static/media/exitModalMobile.41f55ad1.png";